import { Grid, Typography } from "@mui/material";
import { FormikHelpers } from "formik";
import Layout from "../../../core/ui/layout/Layout";
import { useSendApiData } from "../../../core/hooks/useSendApiData";
import { toastError, toastMessage } from "../../../core/utils/ui/alert";
import { parseValidationErrors } from "../../../core/utils/validation";
import { VacancyCreate } from "../vacancy";
import CreateVacancyForm from "../components/CreateVacancyForm";
import ReturnButton from "../../../core/ui/utility/ReturnButton";

const CreateVacancyContainer = () => {
  const { callApi, loading: submitting } = useSendApiData();
  

  const handleSubmit = async (
    values: VacancyCreate,
    { setFieldError }: FormikHelpers<VacancyCreate>
  ) => {
    let success = false;

    const formData: any = { ...values };
    const dateFields: string[] = ["deadline"];
    dateFields.forEach((field) => {
      if (formData[field]) {
        formData[field] = formData[field].toISOString()
        .substring(0, 10) as unknown as Date;
      }
    });

    await callApi({
      endpoint: 'auth-ea35a/vacancies',
      data: formData,
      headers: {
        'Content-Type': 'application/json'
      },
      onValidationError: (err) => parseValidationErrors(err, setFieldError),
      onError: toastError,
      onSuccess: async (_) => {
        toastMessage('Vacancy Created');
        success = true;
      },
    });

    return success;
  };
  

  return (
    <Layout renderLeftToolbar={() => <ReturnButton to="/vacancies" />}>
      <Grid sx={{ p: 2 }}>
        <Grid container sx={{ mb: 2, px: 1 }}>
          <Typography variant="h5">Add Vacancy</Typography>
        </Grid>
        <CreateVacancyForm  onSubmit={handleSubmit} submitting={submitting} />
      </Grid>
    </Layout>
  );
};

export default CreateVacancyContainer;
